import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { getColorMap, getGradeScale } from "../../helpers";

import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/24/solid";
import { useCurrentStat } from "../StatContext";

const Legend = () => {
	const { currentStat } = useCurrentStat();
  const [params, _] = useSearchParams();
  const pqType = currentStat === "thd" ? "thd_8per" : params.get("category");
  const decimalPoints = useMemo(() => currentStat === "thd" ? 1 : 3, [pqType]);

  const gradeElems = useMemo(() => {
    const elems = [];

    [
      getGradeScale(pqType)[0],
      ...getGradeScale(pqType),
      getGradeScale(pqType)[10] + 1,
    ].forEach((color, index, array) => {
      if (index === 12 || index === 0) return;
      const elem = (
        <li
          id={`legend-item-${index}`}
          className={`legend-value-item`}
          key={index}
        >
          <span
            className={`legend-value-color`}
            style={{
              borderColor: "rgba(255, 255, 255, 0.3)",
              backgroundColor: getColorMap(array[index + 1], array, 1),
            }}
          ></span>

          <span className={`legend-value-numbers`}>
            {index === 0 && color.toFixed(decimalPoints)}

            {index === 11 && color.toFixed(decimalPoints) + "+"}

            {index !== 0 &&
              index !== 11 &&
              color.toFixed(decimalPoints) + " - " + array[index + 1].toFixed(decimalPoints)}
          </span>
        </li>
      );

      elems.push(elem);
    });

    return elems;
  }, [pqType]);

  return (
    <section className={`map-legend`} style={{ zIndex: "1000" }}>
		{currentStat === "thd" ? (
			<h2 className={`legend-title`}>Percent of Homes with THD &gt;8%</h2>
		) : null }
      <div className={`map-legend-inner`}>
		<div className="legend-range-container">
			<ul className={`legend-range`}>
			<li className={`legend-range-label worse`}>Worse</li>
			<li className={`legend-range-arrow`}>
				<ChevronRightIcon className={"legend-chevron chevron-right"} />
				<ChevronLeftIcon className={"legend-chevron chevron-left"} />
			</li>
			<li className={`legend-range-label better`}>Better</li>
			</ul>
		</div>

        <ul className={`legend-values-list`}>{gradeElems}</ul>
      </div>
    </section>
  );
};

export default Legend;
